import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './material/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'; 
import { KontaktComponent } from './components/pages/footer-pages/kontakt/kontakt.component';
import { NavbarComponent } from './components/blocks/navbar/navbar.component';
import { HeaderComponent } from './components/blocks/header/header.component';
import { FooterComponent } from './components/blocks/footer/footer.component';
import { MainComponent } from './components/pages/main/main.component';
import { MatSpinnerOverlayComponent } from './components/elemente/mat-spinner-overlay/mat-spinner-overlay.component';
import { AutorenZitierhinweiseComponent } from './components/pages/navbar-pages/autoren-zitierhinweise/autoren-zitierhinweise.component';
import { HilfeComponent } from './components/pages/navbar-pages/hilfe/hilfe.component';
import { QuellenComponent } from './components/pages/navbar-pages/quellen/quellen.component';
import { FaqComponent } from './components/pages/navbar-pages/faq/faq.component';
import { ErgebnisseComponent } from './components/pages/anwendung/ergebnisse/ergebnisse.component';
import { FoerderungComponent } from './components/pages/navbar-pages/foerderung/foerderung.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NavbarComponent,
    FooterComponent, 
    KontaktComponent,
    HilfeComponent,
    AutorenZitierhinweiseComponent,
    PageNotFoundComponent,
    MainComponent,
    MatSpinnerOverlayComponent,
    QuellenComponent,
    FoerderungComponent,
    FaqComponent,
    ErgebnisseComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    FontAwesomeModule 
  ], 
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
